import { useState, useEffect, useReducer, useMemo } from "react";
import { getQueryString } from "utils/url";
import { isIOSDevice } from "utils/device";

// components
import VRTutorial from "../VRTutorial/VRTutorial";
import VRMode from "../VRMode/VRMode";

// 初始化 state
const initialState = { tutorialMode: null, forRWDshowTutorial: true };

function reducer(state, action) {
  switch (action.type) {
    case "openTutorialMode":
      return { tutorialMode: action.payload, forRWDshowTutorial: false };
    case "closeTutorialMode":
      return { tutorialMode: null, forRWDshowTutorial: true };
    default:
      return state;
  }
}

export default function ForVRmaker({ modelIndex, setArStatus, noUsdz, setHiddenModel }) {
  const [forVRstate, forVRdispatch] = useReducer(reducer, initialState);

  const [isQrcode, setQrcode] = useState(false);
  const isVisionPro = useMemo(() => getQueryString("device") === "vision-pro", []);

  const handleArProjection = async () => {
    const getMovelViewer = document.querySelector("#myViewer");

    // 以 model-viewer 的 canActivateAR 能力偵測決定能否直接投放。
    // 採 feature detection，平板即使切換「桌面版網站」模式也能正確判斷；
    // 不支援才顯示 QR code。
    if (!getMovelViewer?.canActivateAR) {
      // 電腦版裝置（無法投放）
      setHiddenModel(true);
      setQrcode(true);
      return;
    }

    setArStatus("偵測裝置中");

    if (isIOSDevice()) {
      // 當使用者使用ios系統開啟（含桌面模式 iPad），判斷物件是否缺少 USDZ
      if (noUsdz) {
        setArStatus("無法使用");
      } else {
        setArStatus("偵測裝置成功");
        await getMovelViewer.activateAR();
      }
    } else {
      // 其餘系統不需判斷檔案，直接開啟AR投放
      setArStatus("偵測裝置成功");
      await getMovelViewer.activateAR();
    }
  };

  useEffect(() => {
    setHiddenModel(false);
    if (forVRstate.tutorialMode === "tutorial") {
      setHiddenModel(true);
    }
    if (forVRstate.tutorialMode === "ARactive") {
      handleArProjection();
    }
  }, [forVRstate]);
  return (
    <div>
      {!isVisionPro && <VRTutorial forVRstate={forVRstate} forVRdispatch={forVRdispatch} />}
      <VRMode
        modelIndex={modelIndex}
        isQrcode={isQrcode}
        forVRstate={forVRstate}
        forVRdispatch={forVRdispatch}
      />
    </div>
  );
}
